import {findLastIndex} from "../../helpers/tools";

export const ANY_FACILITY = "Any facility";
export const ANY_STAKEHOLDER = "Any change stakeholder";
export const ANY_STAKEHOLDER_WITH_MOTIVATION_LESS_THAN_60 = "Any change stakeholder with motivation less than 60%";
export const E1_SELECTED_ONLY_IF_T3_NEVER_SELECTED = "E1 selected, only if T3 never selected";
export const SIX_WEEKS_AFTER_E1 = "6 weeks after E1";
export const TWELVE_WEEKS_AFTER_E1 = "12 weeks after E1";
export const DISTRICT_HAS_REACHED_80_PERCENT_ADOPTION = "District has reached 80% adoption";
export const FACILITY_A_HAS_REACHED_80_PERCENT_ADOPTION = "Facility A has reached 80% adoption";
export const FACILITY_B_HAS_REACHED_80_PERCENT_ADOPTION = "Facility B has reached 80% adoption";
export const FACILITY_C_HAS_REACHED_80_PERCENT_ADOPTION = "Facility C has reached 80% adoption";
export const DISTRICT_80_PERCENT_ADOPTION_PLUS_E1 = "District 80% adoption + E1";
export const E1_PLUS_ANY_FACILITY_HAS_REACHED_80_PERCENT_ADOPTION = "E1 + Any facility has reached 80% adoption";

export const pureActions = [
  {
    id: "I1",
    action:
      "Interview the district health team, health facility staff, and the community at each location to gather information",
    weeks_required: 4,
    repeat_in_weeks: null,
    unlocked_by: "",
    stakeholder_notes: true,
    targeted: false,
    celebration: false,
    action_results: [],
  },
  {
    id: "D1",
    action:
      "Meet with facility managers to analyze local data together and discuss how quality improvement teams could help",
    weeks_required: 3,
    repeat_in_weeks: null,
    unlocked_by: "I1",
    stakeholder_notes: true,
    targeted: false,
    celebration: false,
    action_results: [

      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
    ],
  },
  {
    id: "D2",
    action:
      "Discuss the results of the facility-level data analysis exercise with the district management team",
    weeks_required: 1,
    repeat_in_weeks: null,
    unlocked_by: "D1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Ability",
        value: 2,
      },
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Ability",
        value: 2,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 10,
      },
    ],
  },
  {
    id: "C1",
    action: "Plan communication for these locations",
    weeks_required: 4,
    repeat_in_weeks: null,
    unlocked_by: "",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [],
  },
  {
    id: "C2",
    action:
      "Include information about the change in a newsletter sent to health facilities",
    weeks_required: 1,
    repeat_in_weeks: null,
    unlocked_by: "C1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
    ],
  },
  {
    id: "C3",
    action:
      "Discuss quality improvement teams at quarterly meeting for health facility managers",
    weeks_required: 1,
    repeat_in_weeks: null,
    unlocked_by: "C1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
    ],
  },
  {
    id: "C4",
    action:
      'Send the district health team on a "go and see" to experience how quality improvement has been successfully implemented in another area',
    weeks_required: 2,
    repeat_in_weeks: null,
    unlocked_by: "C1",
    stakeholder_notes: true,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Ability",
        value: 20,
      },
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 20,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Ability",
        value: 20,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 20,
      },
    ],
  },
  {
    id: "C5",
    action: "Meet with the district health team to discuss the change",
    weeks_required: 1,
    repeat_in_weeks: null,
    unlocked_by: "C1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 10,
      },
    ],
  },
  {
    id: "C6",
    action:
      "Meet with health facility staff to discuss plans for engaging community participation in the quality improvement teams",
    weeks_required: 3,
    repeat_in_weeks: null,
    unlocked_by: "C1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Community",
        metric: "Participation",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Community",
        metric: "Participation",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Community",
        metric: "Participation",
        value: 10,
      },
    ],
  },
  {
    id: "T1",
    action: "Plan training and coaching for these locations",
    weeks_required: 4,
    repeat_in_weeks: null,
    unlocked_by: "",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [],
  },
  {
    id: "T2",
    action:
      "Hold a three-day, presentation-focused training for district managers and ask them to cascade what they have learned to health facility staff",
    weeks_required: 4,
    repeat_in_weeks: null,
    unlocked_by: "T1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Ability",
        value: 20,
      },
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 3,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Ability",
        value: 20,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 15,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 3,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 15,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 3,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 3,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 15,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 3,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 3,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 3,
      },
    ],
  },
  {
    id: "T3",
    action:
      "Integrate training into the launch of the quality improvement teams, by planning a hands-on, practice-focused workshop for district and health facility staff the day before the first meeting and in-person support during the meeting",
    weeks_required: 4,
    repeat_in_weeks: null,
    unlocked_by: "T1",
    hidden_by: "E1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    applied: {
      after: "E1",
    },
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Ability",
        value: 40,
      },
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Ability",
        value: 40,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
    ],
  },
  {
    id: "T4",
    action:
      "Integrate training into upcoming quality improvement team meetings, by providing a hands-on, practice-focused workshop for district and health facility staff the day before the meeting and in-person support during the meeting",
    weeks_required: 4,
    repeat_in_weeks: null,
    unlocked_by: E1_SELECTED_ONLY_IF_T3_NEVER_SELECTED,
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Ability",
        value: 40,
      },
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Ability",
        value: 40,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 40,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
    ],
  },
  {
    id: "T5",
    action: "Provide monthly skills-focused coaching for district managers",
    weeks_required: 4,
    repeat_in_weeks: null,
    unlocked_by: "T1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Ability",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Ability",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 10,
      },
    ],
  },
  {
    id: "T6",
    action:
      "Create and distribute competencies checklists for district managers to use when coaching facility staff during supportive supervision visits",
    weeks_required: 2,
    repeat_in_weeks: null,
    unlocked_by: "T1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Ability",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Ability",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 2,
      },
    ],
  },
  {
    id: "T7",
    action:
      "Create and distribute job aids that help health facility staff better engage with the community",
    weeks_required: 2,
    repeat_in_weeks: null,
    unlocked_by: "T1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Community",
        metric: "Participation",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Community",
        metric: "Participation",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Community",
        metric: "Participation",
        value: 10,
      },
    ],
  },
  {
    id: "E1",
    action:
      "Ask health facility staff to form quality improvement teams and start iterative problem solving",
    weeks_required: 2,
    repeat_in_weeks: null,
    unlocked_by: "",
    stakeholder_notes: true,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Community",
        metric: "Participation",
        value: 30,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: -5,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: -5,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Community",
        metric: "Participation",
        value: 20,
      },
    ],
  },
  {
    id: "E2",
    action: "Celebrate the start of the quality improvement teams",
    weeks_required: 1,
    repeat_in_weeks: null,
    unlocked_by: "E1",
    stakeholder_notes: false,
    targeted: false,
    celebration: true,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
    ],
  },
  {
    id: "E3",
    action:
      "Celebrate the initial successes of the quality improvement teams",
    weeks_required: 1,
    repeat_in_weeks: null,
    unlocked_by: SIX_WEEKS_AFTER_E1,
    stakeholder_notes: false,
    targeted: false,
    celebration: true,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
    ],
  },
  {
    id: "E4",
    action:
      "Publically recognize facility A for effectively implementing the change",
    weeks_required: 1,
    repeat_in_weeks: null,
    unlocked_by: FACILITY_A_HAS_REACHED_80_PERCENT_ADOPTION,
    stakeholder_notes: false,
    targeted: false,
    celebration: true,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
    ],
  },
  {
    id: "E5",
    action:
      "Publically recognize facility B for effectively implementing the change",
    weeks_required: 1,
    repeat_in_weeks: null,
    unlocked_by: FACILITY_B_HAS_REACHED_80_PERCENT_ADOPTION,
    stakeholder_notes: false,
    targeted: false,
    celebration: true,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
    ],
  },
  {
    id: "E6",
    action:
      "Publically recognize facility C for effectively implementing the change",
    weeks_required: 1,
    repeat_in_weeks: null,
    unlocked_by: FACILITY_C_HAS_REACHED_80_PERCENT_ADOPTION,
    stakeholder_notes: false,
    targeted: false,
    celebration: true,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
    ],
  },
  {
    id: "R1",
    action: "Celebrate the ongoing progress of the quality improvement teams",
    weeks_required: 1,
    repeat_in_weeks: 6,
    unlocked_by: TWELVE_WEEKS_AFTER_E1,
    stakeholder_notes: false,
    targeted: false,
    celebration: true,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
    ],
  },
  {
    id: "R2",
    action:
      "Ask district managers to discuss the importance of the change with health facility staff during supportive supervisions visits",
    weeks_required: 1,
    repeat_in_weeks: 8,
    unlocked_by: DISTRICT_HAS_REACHED_80_PERCENT_ADOPTION,
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
    ],
  },
  {
    id: "R3",
    action:
      "Ask the regional manager to communicate with the district managers about the importance of the change",
    weeks_required: 1,
    repeat_in_weeks: 8,
    unlocked_by: "C1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 10,
      },
    ],
  },
  {
    id: "R4",
    action:
      "Send email from MoH telling district managers that they need to work harder to implement the change ",
    weeks_required: 1,
    repeat_in_weeks: 4,
    unlocked_by: "C1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: -10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: -10,
      },
    ],
  },
  {
    id: "R5",
    action:
      "Ask all facility managers to present about progress at the next quarterly meeting",
    weeks_required: 1,
    repeat_in_weeks: 12,
    unlocked_by: "E1",
    stakeholder_notes: false,
    targeted: false,
    celebration: false,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
    ],
  },
  {
    id: "TP1",
    action:
      "Tell a resistant stakeholder why they are wrong for not yet implementing the change",
    weeks_required: 1,
    repeat_in_weeks: 1,
    unlocked_by: "E1",
    stakeholder_notes: false,
    targeted: ANY_STAKEHOLDER_WITH_MOTIVATION_LESS_THAN_60,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: -10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: -10,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: -10,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: -10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: -10,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: -10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: -10,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: -10,
      },
    ],
  },
  {
    id: "TP2",
    action:
      "Schedule an extra supportive supervision session at a facility to role model problem solving skills",
    weeks_required: 2,
    repeat_in_weeks: 4,
    unlocked_by: DISTRICT_80_PERCENT_ADOPTION_PLUS_E1,
    stakeholder_notes: false,
    targeted: ANY_FACILITY,
    celebration: false,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
    ],
  },
  {
    id: "TP3",
    action:
      "Ask a project sponsor to provide additional on-site support to facility",
    weeks_required: 2,
    repeat_in_weeks: 4,
    unlocked_by: "E1",
    stakeholder_notes: false,
    targeted: ANY_FACILITY,
    celebration: false,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
    ],
  },
  {
    id: "TP4",
    action:
      'Organize a "go and see" for staff to experience how the change is being implemented at another facility',
    weeks_required: 2,
    repeat_in_weeks: 4,
    unlocked_by: E1_PLUS_ANY_FACILITY_HAS_REACHED_80_PERCENT_ADOPTION,
    stakeholder_notes: false,
    targeted: ANY_FACILITY,
    celebration: false,
    action_results: [
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 20,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 20,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 20,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 20,
      },
    ],
  },
  {
    id: "TP5",
    action:
      "Send a project sponsor to meet with a stakeholder and discuss the importance of the change",
    weeks_required: 2,
    repeat_in_weeks: 4,
    unlocked_by: "E1",
    stakeholder_notes: false,
    targeted: ANY_STAKEHOLDER,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 10,
      },
    ],
  },
  {
    id: "TP6",
    action:
      "Assist health facility staff with engaging community participation in the quality improvement teams",
    weeks_required: 2,
    repeat_in_weeks: 4,
    unlocked_by: "E1",
    stakeholder_notes: false,
    targeted: ANY_FACILITY,
    celebration: false,
    action_results: [
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityA",
        stakeholder: "Community",
        metric: "Participation",
        value: 40,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityB",
        stakeholder: "Community",
        metric: "Participation",
        value: 40,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 2,
      },
      {
        location: "FacilityC",
        stakeholder: "Community",
        metric: "Participation",
        value: 40,
      },
    ],
  },
  {
    id: "TP7",
    action:
      "Provide additional, personalized hands-on training to a stakeholder",
    weeks_required: 2,
    repeat_in_weeks: 4,
    unlocked_by: "T1",
    stakeholder_notes: false,
    targeted: ANY_STAKEHOLDER,
    celebration: false,
    action_results: [
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Ability",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "EPI",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Ability",
        value: 10,
      },
      {
        location: "DHT",
        stakeholder: "HO",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityA",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityB",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Manager",
        metric: "Motivation",
        value: 5,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Ability",
        value: 10,
      },
      {
        location: "FacilityC",
        stakeholder: "Vaccinator",
        metric: "Motivation",
        value: 5,
      },
    ],
  },
];

/**
 *
 * @param history
 * @param locations
 * @returns {*[]}
 */
export function fetchActions(history = [], locations = []) {
  return pureActions.filter(each => {
    if (each.hidden_by) {
      const condition = history.findIndex(i => i.id === each.hidden_by) >= 0;
      if (condition) {
        return false;
      }
    }
    if (each.unlocked_by) {
      const condition = history.findIndex(i => i.id === each.unlocked_by) >= 0;
      if (condition) {
        return true;
      } else {
        const E1Index = findLastIndex(history, 'id', 'E1');
        const conditionI = E1Index >= 0;
        const weeksAfterE1 = history
          .filter((_, index) => index > E1Index)
          .reduce((x, y) => x + y.weeks_required, 0);
        switch (each.unlocked_by) {

          case E1_SELECTED_ONLY_IF_T3_NEVER_SELECTED: {
            const conditionII = history.findIndex(i => i.id === 'T3') < 0;
            return conditionI && conditionII;
          }

          case SIX_WEEKS_AFTER_E1: {
            return conditionI && weeksAfterE1 >= 6;
          }

          case TWELVE_WEEKS_AFTER_E1: {
            return conditionI && weeksAfterE1 >= 12;
          }

          case DISTRICT_HAS_REACHED_80_PERCENT_ADOPTION: {
            const facility = locations.find(i => i.id === 'DHT');
            return facility && facility.adoption >= 80;
          }

          case FACILITY_A_HAS_REACHED_80_PERCENT_ADOPTION: {
            const facility = locations.find(i => i.id === 'FacilityA');
            return facility && facility.adoption >= 80;
          }

          case FACILITY_B_HAS_REACHED_80_PERCENT_ADOPTION: {
            const facility = locations.find(i => i.id === 'FacilityB');
            return facility && facility.adoption >= 80;
          }

          case FACILITY_C_HAS_REACHED_80_PERCENT_ADOPTION: {
            const facility = locations.find(i => i.id === 'FacilityC');
            return facility && facility.adoption >= 80;
          }

          case DISTRICT_80_PERCENT_ADOPTION_PLUS_E1: {
            const facility = locations.find(i => i.id === 'DHT');
            return conditionI && facility && facility.adoption >= 80;
          }

          case E1_PLUS_ANY_FACILITY_HAS_REACHED_80_PERCENT_ADOPTION: {
            return conditionI && locations.filter(each => each.id !== 'DHT').some(each => each.adoption >= 80);
          }

          default: return false;
        }
      }
    }
    
    return true;
  });
}
